<template>
  <div class="inline-flex items-center gap-1 paragraph-sm">
    <span>{{ __("Fait avec", "gestes") }}</span>
    <span class="i-lucide-heart size-5" />
    <span>{{ __("par", "gestes") }}</span>
    <a href="https://websimple.com" target="_blank" rel="noopener noreferrer"> Websimple </a>
  </div>
</template>
